<template>
  <v-card-text>
    <history-list
      :entity-id="incidentId"
      :status-history-refresh-key="statusHistoryRefreshKey"
      :status-history-request="incidentStatusHistory">
    </history-list>
  </v-card-text>
</template>

<script setup lang="ts">
import HistoryList from '@/components/history/HistoryList.vue'
import { incidentStatusHistory } from '@/requests/history'
import { useIncident } from '../Incident'

defineOptions({
  name: 'IncidentHistory',
})

const { incidentId, statusHistoryRefreshKey } = useIncident()
</script>
